import { Tabs } from 'react-tabs';
import styled from 'styled-components';
import { Icon } from '../icon';

export const ZTabs = styled(Tabs)`

    .react-tabs {
        -webkit-tap-highlight-color: transparent;

        &__tab-list {
            position: relative;
            margin: 0 0 16px;
            padding: 2px;
            width: fit-content;
            overflow: visible;
            display: inline-flex;
            min-width: 0;
            flex-wrap: nowrap;
            gap: 2px;
            background: #ececef;
            border-radius: 8px;
            border: none;

            &.has-overflow {
                overflow-x: auto;
                scrollbar-width: none;

                &::-webkit-scrollbar {
                    display: none;
                }
            }
        }

        &__tab-overflow {
            position: sticky;
            right: 0;
            top: 0;
            margin-left: auto;
            background: transparent !important;
            border: none !important;
            border-radius: 6px;
            padding: 6px 10px !important;
            min-width: 32px;
            justify-content: center;
        }

        &__tab {
            white-space: nowrap;
            outline: none;
            font-weight: 500;
            display: inline-flex;
            align-items: center;
            gap: 6px;
            list-style: none;
            height: 28px;
            padding: 0 14px;
            box-sizing: border-box;
            cursor: pointer;
            font-size: 13px;
            font-family: inherit;
            color: #71717a;
            background: transparent;
            border: none;
            border-radius: 6px;
            transition: all 0.15s;

            &--selected {
                color: #09090b;
                font-weight: 600;
                background: #fff;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
            }

            &--disabled {
                color: #a1a1aa;
                cursor: default;
            }

            &:hover:not(.react-tabs__tab--selected):not(.react-tabs__tab--disabled) {
                color: #09090b;
            }
        }

        &__tab ${Icon} {
            width: 16px;
            height: 16px;
        }

        &__tab-panel {
            display: none;

            &--selected {
                display: block;
            }
        }
    }
`;
